import React, { useEffect, useState } from 'react'
import { Button, Modal } from "react-bootstrap";
import Axios from "axios";
import ApiUrl from "../../../../api/ApiUrl";
import toast from "react-hot-toast";
import ReactHtmlParser from "react-html-parser";
import Accordion from "react-bootstrap/Accordion";

const ReturnPolicy = () => {
    const [show, setShow] = useState(false);
    const [myData, setMyData] = useState([])
    const cartModalClose = () => setShow(false);
    const cartModalShow = () => setShow(true);

    useEffect(() => {
        Axios.get(ApiUrl.Faqs).then(response => {
            if (response.status === 200) {
                setMyData(response.data.data)
            }
        }).catch(error => {
            toast.error("Request failed ! try again");
        })
    }, [])

    return (
        <div>
            <div className="" onClick={cartModalShow}>
                Faq
            </div>

            <Modal className="condition-modal" show={show} onHide={cartModalClose} animation={false}>
                <Modal.Header closeButton style={{ border: 'none' }}>
                </Modal.Header>
                <Modal.Title className="text-center" style={{ fontSize: '25px', fontWeight: '600' }}><span>{myData.title}</span></Modal.Title>
                <Modal.Body>
                    <div className="row">
                        <div className="footer-menu-title text-center">Faq</div>
                    </div>
                    <div className="police-page-wrap">
                        <div className="row">
                            {
                                myData.map((value, i) => {
                                    return (
                                        <div className="col-md-9 mx-auto" key={i}>
                                            <div className="footer-menu-content">
                                                <Accordion>
                                                    <Accordion.Item className="policy-item" eventKey="0">
                                                        <Accordion.Header>{ReactHtmlParser(value.title)}</Accordion.Header>
                                                        <Accordion.Body>
                                                            <p>{ReactHtmlParser(value.body)}</p>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ border: 'none' }}>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ReturnPolicy;
